export default __webpack_public_path__ + "static/Special Lamination Category-3dc026e70d8e04049e1c3dac73d4fa8e.webp";